import { useTranslation } from 'react-i18next';

export const useMenuItems = () => {
    const { t } = useTranslation();
    return [
        { id: 'home', label: t('menu.home', 'Головна'), route: '/' },
        {
            id: 'info',
            label: t('menu.useful_information', 'Корисна інформація'),
            children: [
                {
                    id: 'instruction',
                    label: t(
                        'menu.cabinet_instruction',
                        'Інструкція користувача Кабінету Заявника'
                    ),
                    route: '/cabinet-dec-instructions.pdf',
                    external: true,
                },
                {
                    id: 'access-info',
                    label: t(
                        'menu.access_recovery_info',
                        'Інформація щодо видачі або відновлення доступу до системи'
                    ),
                    route: 'https://dec.gov.ua/populyarni-pytannya/',
                    external: true,
                },
                {
                    id: 'personal-data-notice',
                    label: t(
                        'menu.personal_data_notice',
                        'Повідомлення про обробку персональних даних'
                    ),
                    route: '/pro-obrobku-personalnyh-danyh.pdf',
                    external: true,
                },
            ],
        },
    ];
};
